(function () {
    'use strict';

    angular
        .module('app')
        .constant('appConstants', {
            defaultIsoLocale: 'en-GB',
            availiableRenewalPaymentMethods: [
                'Card', 'Credit', 'DirectDebit'
            ],
            AvailableDocumentGroupsByType: {
               mta: 'Upgrade policy documents',
               renew: 'Renewed policy documents',
               newBuisnes:'New business documents',
            },
            // The prefix of the policies needs to map the cancellation reason to "No Longer Participating"
            PolicyPrefixesMappedToNoLongerParticipating: ["GC", "CP", "ISG", "GP", "I4M", "I4S", "PHT", "SME"],
        });

})();
